import React, { FC } from 'react';
import styles from './styles.module.css';
import { Switch, RouteComponentProps, Route } from 'react-router';
import { AnimatePresence } from 'framer-motion';
import { RewardsPortal } from 'Rewards/screens';

export const Router: FC<RouteComponentProps> = ({ match }) => {
  return (
    <div className={styles.container}>
      <AnimatePresence mode="wait">
        <Switch>
          <Route
            path={match.url}
            component={RewardsPortal}
            key="rewardsPortal"
          />
        </Switch>
      </AnimatePresence>
    </div>
  );
};
